import React from "react"

const IntegrationCarouselArrow = ({ onClick, className }) => {
  return (
    <div
      onClick={onClick}
      className={`integration-carousel__arrow ${className}`}
    />
  )
}

export default IntegrationCarouselArrow
